"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageChangeResult = void 0;
/**
 * Enum representing the result of a page change operation.
 */
var PageChangeResult;
(function (PageChangeResult) {
    PageChangeResult[PageChangeResult["SUCCESS"] = 0] = "SUCCESS";
    PageChangeResult[PageChangeResult["PAGE_NOT_FOUND"] = -1] = "PAGE_NOT_FOUND";
    PageChangeResult[PageChangeResult["SET_PAGE_NOT_AVAILABLE"] = -2] = "SET_PAGE_NOT_AVAILABLE";
})(PageChangeResult || (exports.PageChangeResult = PageChangeResult = {}));
//# sourceMappingURL=monitoringService.js.map